var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnect4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_32_269)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_269)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12H60V55H17V12ZM27.1176 17.6912C27.1176 19.7866 25.419 21.4853 23.3235 21.4853C21.2281 21.4853 19.5294 19.7866 19.5294 17.6912C19.5294 15.5957 21.2281 13.8971 23.3235 13.8971C25.419 13.8971 27.1176 15.5957 27.1176 17.6912ZM33.4412 21.4853C35.5366 21.4853 37.2353 19.7866 37.2353 17.6912C37.2353 15.5957 35.5366 13.8971 33.4412 13.8971C31.3457 13.8971 29.6471 15.5957 29.6471 17.6912C29.6471 19.7866 31.3457 21.4853 33.4412 21.4853ZM47.3529 17.6912C47.3529 19.7866 45.6543 21.4853 43.5588 21.4853C41.4634 21.4853 39.7647 19.7866 39.7647 17.6912C39.7647 15.5957 41.4634 13.8971 43.5588 13.8971C45.6543 13.8971 47.3529 15.5957 47.3529 17.6912ZM33.4412 32.2353C35.5366 32.2353 37.2353 30.5366 37.2353 28.4412C37.2353 26.3457 35.5366 24.6471 33.4412 24.6471C31.3457 24.6471 29.6471 26.3457 29.6471 28.4412C29.6471 30.5366 31.3457 32.2353 33.4412 32.2353ZM27.1176 28.4412C27.1176 30.5366 25.419 32.2353 23.3235 32.2353C21.2281 32.2353 19.5294 30.5366 19.5294 28.4412C19.5294 26.3457 21.2281 24.6471 23.3235 24.6471C25.419 24.6471 27.1176 26.3457 27.1176 28.4412ZM23.3235 42.9853C25.419 42.9853 27.1176 41.2866 27.1176 39.1912C27.1176 37.0957 25.419 35.3971 23.3235 35.3971C21.2281 35.3971 19.5294 37.0957 19.5294 39.1912C19.5294 41.2866 21.2281 42.9853 23.3235 42.9853ZM37.2353 39.1912C37.2353 41.2866 35.5366 42.9853 33.4412 42.9853C31.3457 42.9853 29.6471 41.2866 29.6471 39.1912C29.6471 37.0957 31.3457 35.3971 33.4412 35.3971C35.5366 35.3971 37.2353 37.0957 37.2353 39.1912ZM43.5588 42.9853C45.6543 42.9853 47.3529 41.2866 47.3529 39.1912C47.3529 37.0957 45.6543 35.3971 43.5588 35.3971C41.4634 35.3971 39.7647 37.0957 39.7647 39.1912C39.7647 41.2866 41.4634 42.9853 43.5588 42.9853ZM57.4706 39.1912C57.4706 41.2866 55.7719 42.9853 53.6765 42.9853C51.581 42.9853 49.8824 41.2866 49.8824 39.1912C49.8824 37.0957 51.581 35.3971 53.6765 35.3971C55.7719 35.3971 57.4706 37.0957 57.4706 39.1912ZM53.6765 52.4706C55.7719 52.4706 57.4706 50.7719 57.4706 48.6765C57.4706 46.581 55.7719 44.8824 53.6765 44.8824C51.581 44.8824 49.8824 46.581 49.8824 48.6765C49.8824 50.7719 51.581 52.4706 53.6765 52.4706ZM47.3529 48.6765C47.3529 50.7719 45.6543 52.4706 43.5588 52.4706C41.4634 52.4706 39.7647 50.7719 39.7647 48.6765C39.7647 46.581 41.4634 44.8824 43.5588 44.8824C45.6543 44.8824 47.3529 46.581 47.3529 48.6765ZM33.4412 52.4706C35.5366 52.4706 37.2353 50.7719 37.2353 48.6765C37.2353 46.581 35.5366 44.8824 33.4412 44.8824C31.3457 44.8824 29.6471 46.581 29.6471 48.6765C29.6471 50.7719 31.3457 52.4706 33.4412 52.4706ZM27.1176 48.6765C27.1176 50.7719 25.419 52.4706 23.3235 52.4706C21.2281 52.4706 19.5294 50.7719 19.5294 48.6765C19.5294 46.581 21.2281 44.8824 23.3235 44.8824C25.419 44.8824 27.1176 46.581 27.1176 48.6765ZM43.5588 32.2353C45.6543 32.2353 47.3529 30.5366 47.3529 28.4412C47.3529 26.3457 45.6543 24.6471 43.5588 24.6471C41.4634 24.6471 39.7647 26.3457 39.7647 28.4412C39.7647 30.5366 41.4634 32.2353 43.5588 32.2353ZM57.4706 28.4412C57.4706 30.5366 55.7719 32.2353 53.6765 32.2353C51.581 32.2353 49.8824 30.5366 49.8824 28.4412C49.8824 26.3457 51.581 24.6471 53.6765 24.6471C55.7719 24.6471 57.4706 26.3457 57.4706 28.4412ZM53.6765 21.4853C55.7719 21.4853 57.4706 19.7866 57.4706 17.6912C57.4706 15.5957 55.7719 13.8971 53.6765 13.8971C51.581 13.8971 49.8824 15.5957 49.8824 17.6912C49.8824 19.7866 51.581 21.4853 53.6765 21.4853Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_32_269",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32_269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32_269",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "white",
    transform: "translate(17 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect4);
export default __webpack_public_path__ + "static/media/connect4.9e1fc96a5f64ca181075f3e4571942e8.svg";
export { ForwardRef as ReactComponent };